import { get, find, isEmpty } from 'lodash';
import { View } from 'common/types/view';
import { ICellRendererParams } from '@ag-grid-community/core';
import { Configuration } from 'common/visualizations/vif';
import { ActionsConfigs } from '../ProcessDiscoveryButton/types';

interface DescriptorMetadata {
  name: string;
  value: string;
}

type PrimaryKeyValue = string | number;

export interface ApplicationDescriptor {
  id: string;
  url: string;
  metadata: DescriptorMetadata[];
}

export interface ProcessDescriptor {
  id: string;
  name: string;
  url: string;
  metadata: DescriptorMetadata[];
}

export const defaultProcessDiscoveryContext: ActionsConfigs = {
  mappedColumns: null,
  mediaType: '',
  domain: '',
  processDiscoveryApiVersion: 'v1',
};

export const defaultLinkedAction = {
  selectedExistingColumn: '',
  selectedActionForExistingColumn: '',
};

export const getProcessDiscoveryContext = (viewMetadata: View, vifConfig: Configuration): ActionsConfigs => {
  const mappedColumns = vifConfig.contextFieldMappings;

  if (isEmpty(viewMetadata)) {
    return defaultProcessDiscoveryContext;
  }
  const { metadata } = viewMetadata;

  // Prefer VIF configuration, fallback to rowIdentifierColumnId

  const munisContext = find(get(metadata, 'custom_fields', {}), (__, fieldKey) => {
    return fieldKey === 'MUNIS Context Metadata';
  });
  const { Domain: domain, 'Process Discovery API Version': processDiscoveryApiVersion } = munisContext || {};

  return {
    mappedColumns: mappedColumns ?? null,
    mediaType: vifConfig?.actionsMediaType,
    domain,
    processDiscoveryApiVersion,
  };
};

export const getPrimaryKeyValue = (
  rowParams: ICellRendererParams,
  primaryKeyColumn: string,
): PrimaryKeyValue => {
  const { data, node } = rowParams || {};

  const primaryKeyValue = get(data, primaryKeyColumn, '') || get(node, 'data.' + primaryKeyColumn);
  if (primaryKeyValue) {
    return primaryKeyValue;
  } else if (node && node.parent) {
    const { parent } = node;
    return getPrimaryKeyValue(
      { ...rowParams, node: { ...parent, group: true }, data: parent.data },
      primaryKeyColumn,
    );
  } else {
    return '';
  }
};

export const hasEmbeddedExecutionMethod = (applicationDescriptor: ApplicationDescriptor) => {
  const metadata = get(applicationDescriptor, 'metadata', []);
  const embeddedMetadata = find(metadata, { name: 'executionMethod', value: 'Embedded' });
  return !isEmpty(embeddedMetadata);
};
